import * as Lucide from "lucide-react";

const CityDifferentiators = ({ items }) => {
  return (
    <section className="py-24 lg:py-32 bg-white" data-testid="city-differentiators-section">
      <div className="container-tm">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="overline">Notre différence</span>
          <h2 className="mt-5 font-serif font-light text-ink text-4xl md:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
            Mieux encore, ce que vous
            <span className="italic text-gold"> ne trouvez pas ailleurs</span>.
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6 lg:gap-8">
          {items.map((item, i) => {
            const Icon = Lucide[item.icon] || Lucide.Star;
            return (
              <div
                key={item.title}
                data-testid={`city-differentiator-${i}`}
                className="group bg-cream/40 hover:bg-white border border-ink/5 rounded-3xl p-8 lg:p-10 transition-all duration-500 hover:shadow-lift"
              >
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 rounded-2xl bg-sage flex items-center justify-center shrink-0">
                    <Icon size={22} strokeWidth={1.6} className="text-white" />
                  </div>
                  <span className="text-2xl text-gold">✓</span>
                </div>
                <h3 className="font-serif text-2xl text-ink mb-4 leading-tight">
                  {item.title}
                </h3>
                <p className="font-sans text-sm md:text-base text-ink/65 leading-relaxed">
                  {item.text}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CityDifferentiators;
